var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoVer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "15px",
    viewBox: "0 0 24 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico-ver") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "C\\xEDrculo-del-Paciente",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 4,
    transform: "translate(-1311.000000, -447.000000)",
    fill: "#D1D1D1",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar-copy",
    transform: "translate(651.000000, 220.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-ver",
    transform: "translate(660.000000, 227.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C7.41454434,0 3.25621356,2.63040494 0.187787665,6.90288264 C-0.0625958883,7.25291695 -0.0625958883,7.74193548 0.187787665,8.0919698 C3.25621356,12.3695951 7.41454434,15 12,15 C16.5854557,15 20.7437864,12.3695951 23.8122123,8.09711736 C24.0625959,7.74708305 24.0625959,7.25806452 23.8122123,6.9080302 C20.7437864,2.63040494 16.5854557,0 12,0 Z M12.3289353,12.7814001 C9.28505677,12.9821551 6.77140227,10.3517502 6.96287205,7.15511325 C7.11997545,4.51956074 9.15741025,2.38332189 11.6710647,2.21859986 C14.7149432,2.01784489 17.2285977,4.64824983 17.037128,7.84488675 C16.8751151,10.4752917 14.8376803,12.6115305 12.3289353,12.7814001 Z M12.1767413,10.341455 C10.5369745,10.4495539 9.18195766,9.03397392 9.28996625,7.31468771 C9.37342743,5.89396019 10.4731513,4.74605353 11.8281681,4.65339739 C13.4679349,4.54529856 14.8229518,5.96087852 14.7149432,7.68016472 C14.6265726,9.10603981 13.5268487,10.2539465 12.1767413,10.341455 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVer);
export default __webpack_public_path__ + "static/media/ico-ver.cc98ef020b050186266ebfe34b3f2934.svg";
export { ForwardRef as ReactComponent };